/**
 * Reordena cards localmente (optimistic UI) antes da API confirmar o move.
 */
export function applyCardMove(board, { cardId, sourceColumnId, destColumnId, destIndex }) {
  if (!board?.columns?.length) return board;

  const columns = board.columns.map((col) => ({
    ...col,
    cards: [...(col.cards || [])],
  }));

  const sourceCol = columns.find((c) => Number(c.id) === Number(sourceColumnId));
  const destCol = columns.find((c) => Number(c.id) === Number(destColumnId));
  if (!sourceCol || !destCol) return board;

  const fromIdx = sourceCol.cards.findIndex((c) => Number(c.id) === Number(cardId));
  if (fromIdx === -1) return board;

  if (Number(sourceColumnId) === Number(destColumnId) && fromIdx === destIndex) {
    return board;
  }

  const [moved] = sourceCol.cards.splice(fromIdx, 1);

  let insertAt = destIndex;
  if (Number(sourceColumnId) === Number(destColumnId) && fromIdx < destIndex) {
    insertAt = destIndex - 1;
  }

  destCol.cards.splice(insertAt, 0, {
    ...moved,
    columnId: Number(destColumnId),
    position: insertAt,
  });

  sourceCol.cards.forEach((c, i) => {
    c.position = i;
  });
  destCol.cards.forEach((c, i) => {
    c.position = i;
  });

  return { ...board, columns };
}
